import React from 'react'

import { COMPARE_HEADING, type CompareRow } from '../twinContent'

const SERIES = [
  { key: 'rubin', tag: 'Vera Rubin' },
  { key: 'blackwell', tag: 'Blackwell' },
] as const

type Props = { note: string; rows: CompareRow[] }

export function CompareBars({ note, rows }: Props) {
  return (
    <>
      <div className="compare-title">
        {COMPARE_HEADING} - {note}
      </div>
      {rows.map((row) => {
        // bars are relative to the larger of the pair, so any consistent unit works
        const max = Math.max(row.rubin, row.blackwell) || 1
        return (
          <div className="compare-row" key={row.label}>
            <div className="cr-label">{row.label}</div>
            {SERIES.map(({ key, tag }) => (
              <div className={`compare-bar ${key}`} key={key}>
                <div className="cb-tag">{tag}</div>
                <div className="cb-track">
                  <div className="cb-fill" style={{ width: `${Math.max(4, (row[key] / max) * 100)}%` }} />
                </div>
                <div className="cb-val">
                  {row[key]} {row.unit}
                </div>
              </div>
            ))}
          </div>
        )
      })}
    </>
  )
}
